import { useFlags } from "launchdarkly-react-client-sdk";
import { useUser } from "@auth0/nextjs-auth0/client";
import useSegmentTrack from "@/hooks/useSegmentTrack";
import { useRouter } from "next/router";

import useBuyFeeModal from "@/hooks/useBuyFeeModal";
import { BannerContainer, Banner } from "./Banner.styles";

const allowedPaths = [
  "/browse/[[...slug]]",
  "/details/[id]",
  "/mybids/[[...slug]]",
] as const;

type AllowedBuyFeeBannerPath = (typeof allowedPaths)[number];

const segmentComponentMap: Record<AllowedBuyFeeBannerPath, string> = {
  "/browse/[[...slug]]": "SRP",
  "/details/[id]": "VDP",
  "/mybids/[[...slug]]": "my bids",
};

export const isAllowedBuyFeeBannerPath = (
  pathname: string,
): pathname is AllowedBuyFeeBannerPath =>
  allowedPaths.includes(pathname as AllowedBuyFeeBannerPath);

const BuyFeeBanner = () => {
  const { BuyFeeModal, openModal } = useBuyFeeModal();
  const { user } = useUser();
  const { pathname } = useRouter();
  const doSegmentTrack = useSegmentTrack();
  const { auctionBuyFeeBanner } = useFlags<{
    auctionBuyFeeBanner:
      | { enabled: boolean; linkLabel: string; message: string }
      | undefined;
  }>();

  const onViewClick = () => {
    openModal();
    doSegmentTrack("Buy Fee Schedule Viewed", {
      props: {
        component: segmentComponentMap[pathname as AllowedBuyFeeBannerPath],
        rep_id: user?.representativeId ?? "unknown",
      },
    });
  };

  return (
    <BannerContainer>
      <Banner data-qa="buy-fee-banner" type="informational" open icon>
        <Banner.Headline>{auctionBuyFeeBanner?.message}</Banner.Headline>
        <Banner.Link as="button" onClick={onViewClick}>
          {auctionBuyFeeBanner?.linkLabel}
        </Banner.Link>
      </Banner>
      <BuyFeeModal />
    </BannerContainer>
  );
};

export default BuyFeeBanner;
